import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";
import { Tool } from "./types";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function getApiUrl(tool: Tool): string {
  switch (tool) {
    case "tgb":
      return process.env.REACT_APP_TGB_API_URL || "";
    case "tgv":
      return process.env.REACT_APP_TGV_API_URL || "";
    case "tgt":
      return process.env.REACT_APP_TGT_API_URL || "";
    default:
      return "";
  }
}

export interface StoredAuthData {
  email: string;
  otp: string;
  expiryTime: number;
  sessionToken?: string;
}

const EXPIRY_HOURS = 24;
const STORAGE_PREFIX = "tool_auth_";

export function storeAuthData(
  tool: Tool,
  email: string,
  otp: string,
  sessionToken?: string,
): void {
  if (typeof window === "undefined") return;

  const expiryTime = Date.now() + EXPIRY_HOURS * 60 * 60 * 1000;
  let existingSession: string | undefined;
  try {
    const stored = localStorage.getItem(`${STORAGE_PREFIX}${tool}`);
    if (stored) {
      existingSession = (JSON.parse(stored) as StoredAuthData).sessionToken;
    }
  } catch {
    existingSession = undefined;
  }

  const data: StoredAuthData = {
    email,
    otp,
    expiryTime,
    sessionToken: sessionToken || existingSession,
  };

  try {
    localStorage.setItem(`${STORAGE_PREFIX}${tool}`, JSON.stringify(data));
  } catch (error) {
    console.error("Failed to store auth data:", error);
  }
}

export function getStoredAuthData(tool: Tool): StoredAuthData | null {
  if (typeof window === "undefined") return null;

  try {
    const stored = localStorage.getItem(`${STORAGE_PREFIX}${tool}`);
    if (!stored) return null;

    const data: StoredAuthData = JSON.parse(stored);

    if (Date.now() > data.expiryTime) {
      clearAuthData(tool);
      return null;
    }

    return data;
  } catch (error) {
    console.error("Failed to retrieve auth data:", error);
    return null;
  }
}

export function clearAuthData(tool: Tool): void {
  if (typeof window === "undefined") return;

  try {
    localStorage.removeItem(`${STORAGE_PREFIX}${tool}`);
  } catch (error) {
    console.error("Failed to clear auth data:", error);
  }
}
